import { Injectable } from '@angular/core';
import { WebSocketEventRoutingService } from './web-socket-event-routing.service';
import { Observable, Subject } from 'rxjs/Rx';
import { WSEventType } from '../../../models/WSEventType';

@Injectable({
  providedIn: 'root'
})
export class AuthenticateWebSocketHandlerService {

  public isAuthenticated: boolean = false;
  public authObservable: Observable<any>;

  private _authSubject: Subject<any>;

  constructor(private _webSocketEventRoutingService: WebSocketEventRoutingService) {
    let subject = new Subject<any>();
    subject.asObservable().subscribe(response => {
      this.processAuthenticationResponse(response);
    });
    this._webSocketEventRoutingService.subscribe(WSEventType.AUTH_STATUS, subject);
    this._authSubject = new Subject();
    this.authObservable = this._authSubject.asObservable()
  }

  private processAuthenticationResponse(response: any) {
    if ('OK' === response.body.connectionStatus.status) {
      this.isAuthenticated = true;
      this._authSubject.next();
    } else {
      this._authSubject.complete();
    }
  }
}

